import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getBasicItemTypeHandler from '@blaze-cms/utils/src/item-type-handlers/basic-item-type-handler';
import { PROVIDER_TYPE_NAME, REQUIRED_PROPERTIES } from '../constants';
import { LOGIN_MUTATION } from '../mutations';
import handleLogin from './handle-login';
import getApiCredentialsSetting from './get-api-credentials-setting';
const getProviderHandler = () => {
  const baseHandler = getBasicItemTypeHandler(PROVIDER_TYPE_NAME, {
    requiredProperties: REQUIRED_PROPERTIES
  });
  let providerOrder;
  let autoLoginDone = false;
  function setProviderOrder(order) {
    providerOrder = order;
  }
  function getInOrder(order = providerOrder) {
    if (!order || !order.length) return baseHandler.getAll();
    return order.map(providerKey => baseHandler.get(providerKey)).filter(Boolean);
  }
  function getProviderLoginVariables(key, variables) {
    return {
      input: _objectSpread(_objectSpread({}, variables), {}, {
        provider: key
      })
    };
  }
  async function autoLogin(client, ctx) {
    if (autoLoginDone) return; // stops autoLogin running more than once

    await Promise.all(getInOrder().map(async ({
      key,
      getAutoLoginData,
      afterAutoLogin
    }) => {
      if (!getAutoLoginData) return null;
      try {
        const authData = await getAutoLoginData({
          ctx
        });
        if (authData) {
          autoLoginDone = true; // if an auto login is attempted, we don't want to try again
          const {
            data
          } = await client.mutate({
            mutation: LOGIN_MUTATION,
            variables: getProviderLoginVariables(key, authData),
            context: {
              credentials: getApiCredentialsSetting()
            }
          });
          await handleLogin(data, client);
          if (afterAutoLogin) return afterAutoLogin({
            data,
            client,
            ctx
          });
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
      return null;
    }));
    if (ctx) autoLoginDone = true; // only set to true if ctx is true so all providers have a chance to autoLogin
  }
  return _objectSpread(_objectSpread({}, baseHandler), {}, {
    setupComplete: false,
    getInOrder,
    setProviderOrder,
    getProviderLoginVariables,
    autoLogin
  });
};
export default getProviderHandler();
//# sourceMappingURL=provider-handler.js.map